import { Pill } from '../../../web/components-v2/Pill';
import { ITimeEntry, TimeEntryDayBlock } from '../../queries/TimeEntry';

type PillColor = 'gray' | 'blue' | 'green' | 'red' | 'orange' | 'purple';

export function getTimeEntryStatusLabel({
	entry,
	block,
	isOverdue,
}: {
	entry?: ITimeEntry;
	block?: TimeEntryDayBlock;
	isOverdue?: boolean;
}): { label: string; color: PillColor } {
	switch (entry?.status) {
		case 'Approved':
			return { color: 'green', label: 'Approved' };
		case 'Submitted':
			return { color: 'blue', label: 'Waiting for review' };
		case 'Rejected':
			return { color: 'red', label: entry.lastApprovedAt ? 'Reopened' : 'Sent back' };
		case 'Draft':
			return isOverdue ? { color: 'orange', label: 'Overdue' } : { color: 'gray', label: 'Not submitted' };
		default:
			if (block === 'Weekend') {
				return { color: 'gray', label: 'Weekend' };
			}
			if (block === 'Holiday') {
				return { color: 'gray', label: 'Holiday' };
			}
			return isOverdue ? { color: 'orange', label: 'Overdue' } : { color: 'gray', label: 'Not entered' };
	}
}

export function TimeEntryStatusPill(props: { entry?: ITimeEntry; block?: TimeEntryDayBlock; isOverdue?: boolean }) {
	const { label, color } = getTimeEntryStatusLabel(props);
	return <Pill variant='label' color={color} label={label} />;
}
